import { ActionHandler } from '../../../common/actions/core/action-handler';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { Action } from '../../../common/actions/core/action';
import { OpenDoubleOptSuccessDialogAction } from './double-opt-success-dialog.action';
import TokenRedirectService from '../../../common/services/token-redirect.service';
import MobileService from '../../../common/services/mobile.service';
import { ListeningPackageSegment } from '../../../common/services/package/package.model';

/*@ngInject*/
export default class OpenDoubleOptSuccessDialogController
  implements ActionHandler {
  private dialogElement;
  protected isMobile:boolean = false; 
  private type: ListeningPackageSegment;

  constructor(
    protected $element,
    private config,
    private $state,
    private $window,
    private tokenRedirectService: TokenRedirectService,
    protected actionDispatcher: ActionDispatcherService,
    protected mobileService: MobileService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element
      .find('#double-opt-success-dialog')
      .remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenDoubleOptSuccessDialogAction) {
      this.type = action.type;
      this.openDialog();
    }
  }

  protected onListen() {
    try {
      if(localStorage.getItem('fizyWEB')) {
        this.close();
      } else {
        this.tokenRedirectService.openPlayer();
      }
    } catch(error) {
      this.close();
    } 

  }

  protected startListen(){
    this.$window.open('https://fizy.in/Ps93n', '_blank');
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
    if(this.mobileService.isMobile()){
      this.isMobile = true;
    }
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    const fizyWEB = localStorage.getItem('fizyWEB');
    if(fizyWEB){
      console.log('fizyHomePage', this.config.fizyHomePage);
      this.$window.top.location.href = this.config.fizyHomePage;
    } else {
      this.$window.location.href = "/?buySuccess=1"
      this.$window.scrollTo(0,0);
    }

  }

  public isStandartMessageSegment() {
    return !this.isAudioBookSegment() && !this.isPremiumPlusSegment();
  }

  public isAudioBookSegment() {
    return this.type === ListeningPackageSegment.SESLI;
  }

  public isPremiumPlusSegment() {
    return (
      this.type === ListeningPackageSegment.BUNDLE_SESLI ||
      this.type === ListeningPackageSegment.BUNDLE_AUDIOBOOK ||
      this.type === ListeningPackageSegment.BIREYSEL_SESLI
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/double-opt-dialog/success/double-opt-success-dialog.controller.ts